import { htmlToMarkdown } from './pm/markdown/html-to-md'
import { MDToHTML } from './pm/markdown/md-to-html'
import Editor, { RichTextEditorData } from './src/MDTextEditor'
import { ReferenceBlock, ReferencePopup } from './src/reference-popup/ReferencePopup'
import { ShowRichtextPopupData } from './src/richtext-popup/state/richtext-popup-redux'

export { default as RichTextPopup } from './src/richtext-popup/RichtextPopup'
export type { ReferenceBlock, RichTextEditorData }
export { ReferencePopup }
export { LINE_WIDTH, lineWidthStyle } from './src/line-breaks'
export { htmlToMarkdown, MDToHTML }
export default Editor
export type { ShowRichtextPopupData }

export {
  default as richTextPopupReducer,
  showRichtextPopup,
  hideRichtextPopup,
} from './src/richtext-popup/state/richtext-popup-redux'

export {
  showReferencePopup,
  hideReferencePopup,
} from './src/reference-popup/state/reference-popup-actions'

export { reducer as referencePopupReducer } from './src/reference-popup/state/reference-popup-reducer'
